import './Pills.css';

/* Glyphs drawn as SVG so + − × share one optical centre (font glyphs don't). */
const GLYPH = {
  add:    <path d="M6 1.5v9M1.5 6h9" />,
  remove: <path d="M1.5 6h9" />,
  close:  <path d="M2.5 2.5l7 7M9.5 2.5l-7 7" />,
};
function Glyph({ kind, className }) {
  return (
    <svg className={className} viewBox="0 0 12 12" width="10" height="10" fill="none" stroke="currentColor"
      strokeWidth="1.8" strokeLinecap="round" aria-hidden="true">
      {GLYPH[kind]}
    </svg>
  );
}

/**
 * A single pill.
 * variant: "add" | "remove" | "set"   ("set" = a single-value pick, no sign)
 * onRemove: optional — when provided, shows the × button
 * title:    optional tooltip
 */
export function Pill({ variant = 'add', label, title, onRemove }) {
  const sign = variant === 'add' || variant === 'remove' ? variant : null;
  return (
    <span className={`pill pill--${variant}`} title={title}>
      {sign && <span className="pill__sign"><Glyph kind={sign} /></span>}
      <span className="pill__label">{label}</span>
      {onRemove && (
        <button
          type="button"
          className="pill__close"
          aria-label={`Remove ${label}`}
          onClick={onRemove}
        >
          <Glyph kind="close" />
        </button>
      )}
    </span>
  );
}

/**
 * A wrapping set of pills.
 * items: [{ id, label, variant, title? }]
 */
export function PillSet({ items, onRemove }) {
  if (!items?.length) return null;
  return (
    <div className="pill-set">
      {items.map((item) => (
        <Pill
          key={item.id}
          variant={item.variant}
          label={item.label}
          title={item.title}
          onRemove={onRemove ? () => onRemove(item.id) : undefined}
        />
      ))}
    </div>
  );
}
